export default __webpack_public_path__ + "static/media/avatar-blur-03.9d2d68d7.png";